import React from 'react';
import { colors } from '../../styles/colors';
import PLTable from './PLTable';
import PLTableRow from './PLTableRow';

/**
 * Tableau P&L - CA et Marge
 */
function PLCAMargeTable({ calculations, formatMontant }) {
  return (
    <PLTable title="">
      <PLTableRow
        label="CHIFFRE D'AFFAIRES"
        data={calculations.ca}
        formatValue={formatMontant}
        style={{
          backgroundColor: colors.primary.gold,
          fontWeight: '600'
        }}
        labelStyle={{ color: colors.primary.gray }}
        valueStyle={{ color: colors.primary.gray }}
      />
      {Object.entries(calculations.chargesByType).map(([type, montants], index) => (
        <PLTableRow
          key={type}
          label={`Charges ${type}s`}
          data={montants}
          formatValue={formatMontant}
          indent
          style={{
            backgroundColor: index % 2 === 0 ? colors.secondary.lightGray : 'white'
          }}
          labelStyle={index % 2 === 0 ? { color: colors.primary.gray } : {}}
          valueStyle={index % 2 === 0 ? { color: colors.primary.gray } : {}}
        />
      ))}
      <PLTableRow
        label="TOTAL CHARGES"
        data={calculations.totalCharges}
        formatValue={formatMontant}
        style={{
          backgroundColor: colors.primary.gray,
          fontWeight: '600',
          borderTop: `2px solid ${colors.primary.gray}`
        }}
        labelStyle={{ color: 'white' }}
        valueStyle={{ color: 'white' }}
      />
      <PLTableRow
        label="MARGE TOTALE"
        data={calculations.margeBrute}
        formatValue={formatMontant}
        style={{
          backgroundColor: colors.primary.teal,
          fontWeight: '700'
        }}
        labelStyle={{ color: 'white' }}
        valueStyle={{ color: 'white' }}
      />
      <PLTableRow
        label="Taux de Marge"
        data={calculations.margeBrute}
        formatValue={(val, period) => {
          const caValue = calculations.ca[period];
          return caValue > 0 ? `${Math.round((val / caValue) * 100)}%` : '0%';
        }}
        style={{
          backgroundColor: 'white',
          fontWeight: '400',
          fontStyle: 'italic',
          fontSize: '0.8125rem',
          lineHeight: '1.2'
        }}
        labelStyle={{ color: colors.primary.teal }}
        valueStyle={{ color: colors.primary.teal }}
      />
    </PLTable>
  );
}

export default PLCAMargeTable;
